import React from "react";
import "./ImagePopup.css";

function ImagePopup({
  imageUrl,
  organization,
  objective,
  verificationDate,
  onClose,
}) {
  return (
    <div>
      <div className="popup-content grey-box">
        <img src={imageUrl} alt={organization} className="popup-image" />
        <div className="popup-text">
          <h2>{organization}</h2>
          <p>{objective}</p>
          <p className="verification-date">Vérifié le : {verificationDate}</p>
        </div>
      </div>
    </div>
  );
}

export default ImagePopup;
